import React, {Component} from "react";

import {LogoColumn, LogoName, Wrapper} from "../../shared-components/Header/Header";
import logoImage from '../../assets/images/home-logo.svg'

import styled from "styled-components/macro";
import breakpoint from "styled-components-breakpoint";
import {Router} from "@reach/router";
import {NoStyleRoute, RoutingLink} from '../../shared-components/RoutingLinks/RoutingLinks'
import {ListArticles} from "./components/ListArticles/ListArticles";
import {CookieNotice} from "../../shared-components/CookieNotice/CookieNotice";
import {SingleArticlePage} from "../SingleArticlePage/SingleArticlePage";
import {articles} from "../Articles/articleDb";

const HeaderRow = styled.div.attrs({
    className: "row",
})`
    box-shadow: -4px 3px 6px rgba(0, 0, 0, 0.16);
    background-color: ${props => props.theme.contrastBackgroundColor};
    
    position: sticky;
    top: 0;
    z-index: 11;
    height: 4.9rem;
    
    ${breakpoint('s')`
        height: 4.1rem;
    `};
    
    align-items: flex-end;
`;

const NoticeRow = styled.div.attrs({
    className: "row",
})`
    position: sticky;
    top: 4.9rem;
    z-index: 1;
    height: 0.5rem;
    text-align: center;
    
     ${breakpoint('s')`
        top: 4.1rem;
    `};

`;

const NoticeColumn = styled.div.attrs({
    className: "col-xs-12 col-sm-12 col-lg-8 col-lg-offset-2",
})`

`;

const HeaderLogoColumn = styled.div.attrs({
    className: "col-xs-12 col-sm-8 col-md-3 col-lg-3",
})`

`;

const ContentRow = styled.div.attrs({
    className: "row",
})`
    margin-top: 3rem;
    ${breakpoint('xs', 'sm')`
        margin-top: 0rem;
    `};
`;

const ContentMainColumn = styled.div.attrs({
    className: "col-md-10 col-md-offset-1 col-xs-12 col-lg-12",
})`
`;


const MainContentContainer = styled.div`
    left: 3rem;
`;

const LogoNameColumn = styled.div.attrs({
    className: "col-xs-offset-3 col-sm-offset-5 col-md-offset-9 col-lg-offset-2",
})`
    margin-top: auto;
    color: ${props => props.theme.primaryColor};
    font-family: ${props => props.theme.logoFontFamily};
`;

const LogoSubHeaderName = styled(LogoName)`
    font-size: 2.3rem;
    font-family: 'CrimsonBold', Fallback, sans-serif;
`;

const LogoImage = styled.img`
    ${breakpoint('s')`
        height: 5.1rem;
    `}
`;

const NotFound = () => <p>Feeling lost? Checkout our <RoutingLink to={articles[articles.length - 1].relativePath}>latest article!</RoutingLink> or
    go back to <RoutingLink to="/">Main Page</RoutingLink></p>

class BlogMainPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <React.Fragment>
                <HeaderRow>
                    <HeaderLogoColumn>
                        <Wrapper>
                            <NoStyleRoute to="/">
                                <LogoColumn>
                                    <LogoImage src={logoImage}/>
                                </LogoColumn>
                                <LogoNameColumn>
                                    <LogoName>envimate</LogoName><LogoSubHeaderName>/blog</LogoSubHeaderName>
                                </LogoNameColumn>
                            </NoStyleRoute>
                        </Wrapper>
                    </HeaderLogoColumn>
                </HeaderRow>
                <NoticeRow>
                    <NoticeColumn>
                        <CookieNotice/>
                    </NoticeColumn>
                </NoticeRow>
                <ContentRow>
                    <ContentMainColumn>
                        <MainContentContainer>
                            <Router>
                                <ListArticles path="/"/>
                                {articles.map((value) => {
                                    return <SingleArticlePage
                                        key={value.uniqueKey}
                                        header={value.header}
                                        image={value.image}
                                        tags={value.tags}
                                        authorName={value.authorName}
                                        content={value.content}
                                        path={value.relativePath}
                                        summary={value.summary}
                                        shortSummary={value.shortSummary}
                                        readTime={value.readTime}
                                        date={value.date}
                                        relativePath={value.relativePath}
                                    />
                                })}

                                <NotFound default/>
                            </Router>
                        </MainContentContainer>
                    </ContentMainColumn>
                </ContentRow>
            </React.Fragment>
        )
    }
}

export default BlogMainPage;
